import script from "./EditIngredientModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditIngredientModal.vue?vue&type=script&setup=true&lang=js"

import "./EditIngredientModal.vue?vue&type=style&index=0&id=9f2ee718&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f2ee718"]])

export default __exports__